import { LogglyTracker } from 'loggly-jslogger';
const logger = new LogglyTracker();

if (LOGGLY_TOKEN) {
    logger.push({ logglyKey: LOGGLY_TOKEN });
}

export default logger;
